import { useMemo, useCallback } from 'react';
import { DEFAULT_MAX_COUNT } from 'crm-activity-creator-widgets/constants/ButtonConstants';
import { useFetchActivityButtons } from './useFetchActivityButtons';
export const useFetchOrderedActivityButtons = ({
  subjectId,
  objectTypeId
}) => {
  const {
    data,
    error,
    loading,
    updateQuery
  } = useFetchActivityButtons({
    objectTypeId,
    subjectId
  });
  const activityButtonNames = useCallback(activityButtons => {
    return activityButtons && activityButtons.map(button => button.name);
  }, []);
  const allActivityButtonsSorted = useMemo(() => {
    const allActivityButtons = activityButtonNames(data && data.crmObject && data.crmObject.allActivityButtons);
    const selectedActivityButtons = activityButtonNames(data && data.crmObject && data.crmObject.selectedActivityButtons);
    const selectedActivityButtonsSet = new Set(selectedActivityButtons);
    return allActivityButtons && selectedActivityButtons ? [...selectedActivityButtons, ...allActivityButtons.filter(interactionName => !selectedActivityButtonsSet.has(interactionName))] : [];
  }, [data, activityButtonNames]);
  const allAssociationTypesFromObjectTypeToEngagements = useMemo(() => {
    return data && data.allAssociationTypesFromObjectTypeToEngagements && data.allAssociationTypesFromObjectTypeToEngagements.map(associationType => associationType.toObjectTypeId);
  }, [data]);
  const numberVisible = useMemo(() => {
    const selectedActivityButtons = activityButtonNames(data && data.crmObject && data.crmObject.selectedActivityButtons);
    return selectedActivityButtons && selectedActivityButtons.length + 1 < DEFAULT_MAX_COUNT ? selectedActivityButtons.length + 1 : undefined;
  }, [data, activityButtonNames]);
  return {
    allActivityButtonsSorted,
    allAssociationTypesFromObjectTypeToEngagements,
    error,
    loading,
    updateQuery,
    numberVisible
  };
};